interface JqueryXhrLike {
  readonly statusText?: string;
  readonly status?: number;
  readonly responseJSON?: {message?: string} | null;
}

function isJqueryXhrLike(error: unknown): error is JqueryXhrLike {
  return typeof error === 'object' && error !== null && ('responseJSON' in error || 'statusText' in error);
}

/**
 * Extracts a human-readable message from an unknown caught value. Handles native `Error`s and the
 * jQuery `jqXHR` objects that bare `window.PMW.write`/`$.ajax` rejections produce (which are not
 * `Error` instances and stringify to a useless `"[object Object]"`), falling back to `String()`.
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  if (isJqueryXhrLike(error)) {
    return error.responseJSON?.message ?? error.statusText ?? `Request failed${error.status ? ` (${error.status})` : ''}`;
  }

  if (typeof Event !== 'undefined' && error instanceof Event) {
    return `${error.type} event`;
  }

  return String(error);
}
